import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../common/services/api/api.service';
import { environment } from 'src/environments/environment';
import { GETDPIREDUCTIONANALYSIS } from '../common/constants/labels';
@Injectable({
  providedIn: 'root'
})
export class DpiReductionAnalysisService {

  getDpiReductionAnalysisUrl = environment.APISETTINGS + GETDPIREDUCTIONANALYSIS;
  constructor(private service: ApiService) { }

  public getDpiReductionAnalysisData(filterParameter): Observable<any> {
    return this.service.post(this.getDpiReductionAnalysisUrl, filterParameter);
  }
}
